'use strict';


import { showMsg } from '../widgets/poi/poiv3';
import { BaseElement } from '../interfaces/BaseElement';
import { getCurrentLang } from '../components/langSwitcher/langSwitcher';

export class GoogleMaps {
    static sendRequest = false;

    constructor () {
        if (window.google && window.google.maps) {
            return new Promise(resolve => resolve());
        } else if (GoogleMaps.sendRequest) {
            return new Promise(resolve => {
                window.addEventListener('googleMapsAPILoaded', () => {
                    resolve();
                },{once: true});
            });
        } else {
            return GoogleMaps.loadGoogleMapScripts();
        }
    }

    static loadGoogleMapScripts() {
        GoogleMaps.sendRequest = true;
        const link = `https://maps.googleapis.com/maps/api/js?key=${config.googleAPI}&language=${getCurrentLang()}&callback=googleMapsAPILoaded`;
        new BaseElement('script')
          .addAttribute('src',link)
          .appendTo(document.querySelector('head'));

        return new Promise(resolve => {
            window.addEventListener('googleMapsAPILoaded', () => {
                resolve();
            },{once: true});
        });
    }

    static removeGoogleMapScripts() {
        document.querySelectorAll('script[src^="https://maps.googleapis.com"]').forEach(script => {
            script.remove();
        });
        if(window.google) delete window.google.maps;
        document.querySelector('script[id="snazzy"]')?.remove();
        delete window.SnazzyInfoWindow;
        delete require.cache[require.resolve('snazzy-info-window')]
    }

    static getRoute(from,to,travelMode = 'DRIVING') {
        const request = {
            origin: new google.maps.LatLng(from.lat,from.lng),
            destination: new google.maps.LatLng(to.lat,to.lng),
            travelMode
        };
        const service = new google.maps.DirectionsService();

        return new Promise((resolve) => {
            service.route(request, (result,status) =>{
                if (status === 'OK'){
                    resolve(result);
                } else {
                    showMsg('Can not get the route');
                    resolve([]);
                }
            });
        });
    }
}


window.googleMapsAPILoaded = () => {
    let event = new CustomEvent('googleMapsAPILoaded');
    window.dispatchEvent(event);
    window.SnazzyInfoWindow = require('snazzy-info-window');
    GoogleMaps.sendRequest = false;
};
